// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Expand clickable area by increasing padding */
.board-selection {
    display: flex;
    align-items: center;
    padding: 10px 0; /* Increased padding for larger clickable area */
    cursor: pointer;
  }
  
  .board-selection input[type="checkbox"] {
    margin-right: 10px; /* Space between checkbox and label */
  }
  
  .board-selection label {
    cursor: pointer; /* Ensure the label is also clickable */
  }`, "",{"version":3,"sources":["webpack://./src/components/StockConfig.css"],"names":[],"mappings":"AAAA,gDAAgD;AAChD;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe,EAAE,gDAAgD;IACjE,eAAe;EACjB;;EAEA;IACE,kBAAkB,EAAE,qCAAqC;EAC3D;;EAEA;IACE,eAAe,EAAE,uCAAuC;EAC1D","sourcesContent":["/* Expand clickable area by increasing padding */\r\n.board-selection {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 10px 0; /* Increased padding for larger clickable area */\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .board-selection input[type=\"checkbox\"] {\r\n    margin-right: 10px; /* Space between checkbox and label */\r\n  }\r\n  \r\n  .board-selection label {\r\n    cursor: pointer; /* Ensure the label is also clickable */\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
